"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridLogPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Page_1 = require("../Page");
var molecules_1 = require("../../molecules");
var atoms_1 = require("../../atoms");
exports.GridLogPage = react_1.default.memo(function (_a) {
    var title = _a.title, searchBar = _a.searchBar, filterAndSortPanel = _a.filterAndSortPanel, children = _a.children, _b = _a.actionMenuOptions, actionMenuOptions = _b === void 0 ? [] : _b, actionMenuProp = _a.actionMenuProp;
    return ((0, jsx_runtime_1.jsx)(Page_1.Page, __assign({ floatingAction: actionMenuOptions.length ? ((0, jsx_runtime_1.jsx)(molecules_1.MultiOptionsFab, __assign({ "data-testid": actionMenuProp === null || actionMenuProp === void 0 ? void 0 : actionMenuProp.dataTestId }, actionMenuProp, { options: actionMenuOptions }))) : undefined }, { children: (0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ style: { display: "flex", flexDirection: "column", height: "90vh" } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Box, __assign({ display: "flex", justifyContent: "space-between", alignItems: "center", alignContent: "center" }, { children: (0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ flexGrow: "1", paddingRight: "24px" }, { children: [(0, jsx_runtime_1.jsx)(atoms_1.PageHeader, { title: title }), (0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ display: "flex", justifyContent: "space-between", style: { marginBottom: "10px" } }, { children: [searchBar || null, filterAndSortPanel || null] }))] })) })), children || null] })) })));
});
